import { Route, Routes, useLocation } from "react-router-dom";

import Orgs from "../../pages/admin/Orgs";
import Org from "../../pages/admin/Org";
import Users from "../../pages/admin/Users";
import Logs from "../../pages/admin/Logs";
import User from "../../pages/admin/User";
import AppLogs from "../../pages/admin/AppLogs";

const AdminRoutes = ({
  navigateWorkspace,
  handleLoginAs,
  userData,
  orgData,
}) => {
  const location = useLocation();

  return (
    <Routes>
      <Route
        path="/orgs"
        element={<Orgs navigateWorkspace={navigateWorkspace} />}
      />
      <Route
        path="/org/:id"
        element={
          <Org
            userData={userData}
            orgData={orgData}
            navigateWorkspace={navigateWorkspace}
            handleLoginAs={handleLoginAs}
          />
        }
      />
      <Route
        path="/users"
        element={<Users navigateWorkspace={navigateWorkspace} />}
      />

      <Route
        path="/user/:id"
        element={
          <User
            navigateWorkspace={navigateWorkspace}
            handleLoginAs={handleLoginAs}
          />
        }
      />
      <Route
        path="/logs"
        element={<Logs navigateWorkspace={navigateWorkspace} />}
      />
      <Route
        path="/applogs"
        element={<AppLogs navigateWorkspace={navigateWorkspace} />}
      />
    </Routes>
  );
};

export default AdminRoutes;
